export default __webpack_public_path__ + "static/website-logo-7e598be241d2188047001e26e471559f.png";